<template>
  <v-container fluid tag="section">
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{
          $t(tessera ? tessera.title : "select_affiliation_card")
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{ $t("accept_condition")
        }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :step="3" :editable="stepper >= 3" :complete="stepper > 3">{{ $t("select_users")
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :step="4" :editable="stepper >= 4" :complete="stepper > 4">{{ $t("exec_payment")
        }}</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1">
          <list-tessere :disableRedirect="true" @selected="selectTessera"></list-tessere>
        </v-stepper-content>
        <v-stepper-content :step="2">
          <accept-condition v-if="tessera" :idTessera="tessera.tesId" @confirmed="confirmTerms"></accept-condition>
        </v-stepper-content>
        <v-stepper-content :step="3">
          <v-row>
            <v-col cols="12">
              <DataTables @showUser="showUser" :headers="headers" :selected="selected" :showSelect="true"
                itemKey="masterId" v-model="selected" :tableData="tableData"></DataTables>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn @click="gotoStep4" color="success">{{
                $t("confirm_choise")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>
        <v-stepper-content :step="4">
          <v-row>
            <v-col cols="12">
              <select-mod-pag v-if="tessera" :riepilogo="riepilogo" @selected="confirmOrder" :usePoint="tessera.buyWithCredits === 1"
                :tesId="tessera.tesId"></select-mod-pag>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            {{ $t("confirm_order") }}
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("beneficiary") }}</td>
                  <td>{{ asdData.ragSoc }}</td>
                </tr>
                <tr>
                  <td>{{ $t("type") }}</td>
                  <td>
                    {{ $t("affiliation_cards") }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("total") }}</td>
                  <td>{{ riepilogo.totale }}</td>
                </tr>
                <tr>
                  <td>{{ $t("payment_date") }}</td>
                  <td>
                    {{
                      params.dataPag
                      ? new Date(params.dataPag).toLocaleDateString("it")
                      : new Date().toLocaleDateString("it")
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">
              {{ $t("undo") }}
            </v-btn>
            <v-btn color="green darken-1" text @click="sendOrder">
              {{ $t("confirm") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <profile-page @isUpdated="loadTable" ref="userProfileDialog"></profile-page>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import selectModPag from "@/widget/selectModPag.vue";
import listTessere from "@/widget/listTessere.vue";
import acceptCondition from "@/widget/acceptCondition.vue";

import Swal from "sweetalert2";
import moment from "moment";

let _ = this;
export default {
  name: "user-2-affiliate",
  components: {
    DataTables,
    listTessere,
    acceptCondition,
    profilePage,
    MyDatepicker,
    selectModPag,
  },
  data() {
    return {
      tessera: null,
      listUpdated: null,
      listError: null,
      dateInz: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateEnd: new Date(),
      dialog: false,
      discipline: null,
      qualifica: null,
      mode: "MyASD",
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("qta"), value: "qta" },
          { text: this.$t("price"), value: "prezzo" },
          { text: this.$t("total"), value: "total" },
        ],
        items: [],
        totale: 0,
      },
      stepper: 1,
      params: {
        pagId: null,
        idDisciplina: null,
        qualifica: null,
        dettaglio: [],
      },
      selected: [],
      headers: [
        { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("card"), value: "tesseraImage", type: "image" },
        {
          text: this.$t("type_affiliation_card_ente"),
          value: "tesseraCorrente",
          type: "html",
        },
        { text: this.$t("price"), value: "prezzo", type: "number" },
        { text: this.$t("date_affiliation"), value: "dateTes", type: "date" },
        { text: this.$t("status"), value: "status", type: "icons" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    selectTessera(tessera) {
      this.tessera = tessera;
      this.stepper = 2;
    },
    confirmTerms(confirmed) {
      let _ = this;
      _.discipline = confirmed.discipline;
      _.qualifica = confirmed.qualifica;
      this.stepper = 3;
    },
    sendOrder: function (data) {
      let _ = this;
      _.dialog = false;
      _.chiamataAxios(
        "POST",
        "/auth/tesseramenti/tesseramentoMassivo/" + _.tessera.tesId,
        { body: _.params, dialogLoader: true }
      ).then((response) => {
        _.$updateCrediti.updateCreditiRsp.updated = new Date();
        if (response.data.payUrl) {
          Swal.fire({
            title: _.$t("redirect_to_external_site"),
            html: _.$t("for_complete_the_payment_operation"),
          }).then((result) => {
            window.open(response.data.payUrl);
          });
        } else {
          Swal.fire({
            type: response.msg.esito ? "success" : "error",
            title: response.msg.esito
              ? _.$t("operation_successfully_completed")
              : _.$t("there_was_an_error"),
            html: response.msg.msgTxt,
          });
        }
        if (response.msg.esito) _.$router.push("/portal/");
      });
    },
    confirmOrder: function (data) {
      this.params.pagId = data.pagId;
      this.params.dataPag = data.dataPag;
      this.params.dexPag = data.title;
      this.dialog = true;
    },
    gotoStep4: function () {
      let _ = this;
      _.riepilogo.totale = 0;
      _.riepilogo.items = [];
      _.params = {
        pagId: null,
        discipline: _.discipline,
        qualifica: _.qualifica,
        tesId: _.tessera.tesId,
        dettaglio: [],
      };
      // Prepara ordine e riepilogo
      for (let utente of _.tableData) {
        if (_.selected.includes(utente.masterId)) {
          _.riepilogo.totale += utente.prezzo;
          _.params.dettaglio.push(utente.masterId);
          _.riepilogo.items.push({
            item:
              _.$t("card") +
              " " +
              _.tessera.title +
              ": " +
              utente.surname +
              " " +
              utente.name,
            qta: 1,
            prezzo: utente.prezzo,
            total: utente.prezzo,
          });
        }
      }
      if (_.riepilogo.items.length > 0) _.stepper = 4;
    },
    showUser(item) {
      this.$refs.userProfileDialog.open(item.masterId, 4);
    },
    loadTable() {
      let _ = this;
      if (_.tessera && _.tessera.tesId) {
        _.tableData = [];
        _.isFetching = true;
        _.chiamataAxios(
          "GET",
          "/auth/tesseramenti/listUser2tesserate/" + _.tessera.tesId
        ).then((response) => {
          let data = response.data.map(function (item) {
            item.tesseraCorrente = null;
            if (item.asdTesId) {
              item.tesseraCorrente =
                '<h4 style="color: ' +
                item.asdTesHexColor +
                ';">' +
                item.asdTesTipo +
                "</h4>";
            }
            item.options = [
              {
                icon: "mdi-magnify",
                color: "primary",
                function: "showUser",
              },
            ];
            if (item.waitingApproval) {
              item.disabled = true;
              item.status = [
                {
                  icon: "mdi-clock-time-three-outline",
                  color: "warning",
                  text: _.$t("data_waiting_for_approvation"),
                },
              ];
            } else item.status = null;

            return item;
          });
          _.tableData = data;
          _.isFetching = false;
        });
      }
    },
  },
  watch: {
    tessera: function (newVal, oldVal) {
      if (newVal.tesId) this.loadTable();
    },
  },
  computed: {
    asdData: function () {
      return window.systemData.ASD;
    },
  },
};
</script>

